export enum SugType {
  normal = 1,
  user = 2,
  hashtag = 3,
}

export interface SearchSugItem {
  id: string;
  /** 推荐名称 */
  text: string;
  /** 推荐词类型，目前展示上只区分用户 */
  type: SugType;
  /** 推荐词来源类型，目前展示上只区分是否历史词（服务端返回可能不止这两种类型） */
  rectType: 'normal' | 'history';
  /** 高亮区域,格式[start, end] */
  highlightPos: [number, number];
  /** 用户头像, type为user时候会有该参数 */
  avatar?: string;
  /** 用户user id, type为user时候会有该参数 */
  userId?: string;
  /** 排序（从0开始） */
  rank?: number;
  /** 是否为认证用户 */
  isUserVerify?: boolean;
  /** 是否为绑定 TT 的账户 */
  belongTT?: boolean;
}
